import authRequest from "../utils/authRequest";

const baseUrl = "/sop-content-type";

export interface ContentType {
  id: string;
  title: string;
  description: string;
  charge_credits: number;
  num_copies: number;
  content_name: string;
}
export const getSOPContentTypes = (type: string) => {
  return new Promise<ContentType[]>((resolve, reject) => {
    const params = {
      sop_type: type,
    };
    authRequest({
      url: `${baseUrl}/all`,
      method: "get",
      params: params,
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
